import { ref, watch } from "vue";

type Theme = "light" | "dark";

// Estado global (fuera del composable para que sea un singleton a lo largo de la app)
const currentTheme = ref<Theme>("light");

export function useTheme() {
  const initTheme = () => {
    // Revisar si ya hay un tema guardado
    const savedTheme = localStorage.getItem("app-theme") as Theme | null;
    if (savedTheme) {
      currentTheme.value = savedTheme;
    } else {
      // Si no hay, usar la preferencia del sistema
      const prefersDark =
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;
      currentTheme.value = prefersDark ? "dark" : "light";
    }
    applyTheme(currentTheme.value);
  };

  const toggleTheme = () => {
    currentTheme.value = currentTheme.value === "light" ? "dark" : "light";
  };

  const applyTheme = (theme: Theme) => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("app-theme", theme);
  };

  // Watcher para aplicar el tema cada vez que cambie programáticamente
  watch(currentTheme, (newTheme) => {
    applyTheme(newTheme);
  });

  return {
    currentTheme,
    toggleTheme,
    initTheme,
  };
}
